import { render, staticRenderFns } from "./FacturesUserView.vue?vue&type=template&id=dd3876f4"
import script from "./FacturesUserView.vue?vue&type=script&lang=js"
export * from "./FacturesUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports